import { initAgentWidget } from "./index";

window.initAgentWidget = initAgentWidget;
